var signWrapper, signCanvas, signCanvasError, signClearButton, signAgreeButton, signaturePad;

$(function() {

	// $('#application-form').on('change', '.ethnicity-wrapper input', function() {
	// 	var field = $(this);
	// 	var inputs = field.parents('.ethnicity-wrapper').find('input');

	// 	inputs.prop('disabled', false);

	// 	if (field.is(':checked') && field.hasClass('none-field')) {
	// 		inputs.not(field).prop('disabled', true);
	// 	} else if (field.parents('.ethnicity-wrapper').find('input:not(".none-field"):checked').length > 0) {
	// 		field.parents('.ethnicity-wrapper').find('input.none-field').prop('disabled', true);
	// 	}
	// });

	$('.char-counter').each(function() {
		$(this).prev('textarea').addClass('counted');
		var min = $(this).attr('data-min');
		var max = $(this).attr('data-max');
		var chars = $(this).prev('textarea').val().length;
		var display = $(this).find('span');
		display.text(chars);
		if (chars < min || chars > max) {
			display.addClass('c-red');
		} else {
			display.removeClass('c-red');
		}
	});

	$('#application-form').on('submit', function(e) {

		$('#application-form input[type="submit"]').prop('disabled', true);

	});

	if ($('.referral-question input[type="checkbox"]:checked').length) {

		$('.referral-question input[type="checkbox"]:checked').each(function() {
			var show_follow_up = $(this).hasClass('referral-followup');
			var parent_el = $(this).parents('.referral-source-option');

			if (show_follow_up) {
				parent_el.find('.referral-source-answer').removeClass('hidden');
				parent_el.find('.referral-source-answer input').prop('disabled', false);
			}	
		});

	}

	$('.referral-question input[type="checkbox"]').on('change', function() {
		var show_follow_up = $(this).hasClass('referral-followup');
		var parent_el = $(this).parents('.referral-source-option');

		if (show_follow_up) {
			// $('#referral-followup-field').remove();
			// var followup_field = $('#referral-followup').clone();
			// followup_field.attr('id', 'referral-followup-field');
			// followup_field.find('input').attr('name', 'referral_source_answer2');
			// var index = $('input[type="radio"]:checked').index('.referral-question input[type="radio"]');
			// if (index % 2) {
			// 	followup_field.addClass('prefix-6@medium');
			// }
			// $('.referral-question input[type="radio"]:checked').parent().after(followup_field);
			if ($(this).is(':checked')) {
				parent_el.find('.referral-source-answer').removeClass('hidden');
				parent_el.find('.referral-source-answer input').prop('disabled', false);
			} else {
				parent_el.find('.referral-source-answer').addClass('hidden');
				parent_el.find('.referral-source-answer input').prop('disabled', true);
			}
		}
	});

	$('#application-form').on('keyup', 'textarea.counted', function() {
		var chars = $(this).val().length;
		var counter = $(this).next('.char-counter');
		var min = counter.attr('data-min');
		var max = counter.attr('data-max');
		counter.find('span').text(chars);
		if (chars < min || chars > max) {
			counter.find('span').addClass('c-red');
		} else {
			counter.find('span').removeClass('c-red');
		}
	});

	$('#no-children').on('change', function() {

		if ($(this).is(':checked')) {
			$('.child-fields').hide();
			$('.add-child-btn').hide();
		} else {
			$('.child-fields').show();
			$('.add-child-btn').show();
		}

	});

	$('#add-child').on('click', function(e) {

		e.preventDefault();

		var current = $('.child-fields .child-field').length;
		var new_id = current + 1;
		if (new_id > 6) {
			return false;
		}
		var child_row = $('.child-fields .child-field:first-child').clone();
		child_row = child_row.html().split('_1_').join('_'+new_id+'_').split('[1]').join('['+new_id+']');
		$('.child-fields').append('<div class="child-field child-field-'+new_id+' row m-b-30">'+child_row+'</div>');
		$('.child-field-'+new_id).find('input:not([type="checkbox"])').val('').end().find('select').val('').end().find('.frm_error').remove();
		$('.child-field-'+new_id).find('input[type="checkbox"]').prop('checked', false);
		$('.child-field-'+new_id).find('input[type="checkbox"]').prop('disabled', false);
		if (new_id > 5) {
			$('#add-child').hide();
		}

	});

	if ($('.signature-pad').length) {

		signCanvas = document.getElementById('signature-pad-canvas');

		if (signCanvas) {
			signWrapper = document.getElementsByClassName("signature-pad");
			if (signWrapper) {
				signClearButton = signWrapper[0].querySelector("[data-action=clear]");
				signAgreeButton = signWrapper[0].querySelector("[data-action=agree]");
			}
			signaturePad();
		}

	}

});

function signaturePad() {
	var signatureError 	= "Please provide us with your autograph.";

	signaturePad = new SignaturePad(signCanvas, {
		backgroundColor: 'rgb(255, 255, 255)'
	});

	window.addEventListener("resize", resizeCanvas);
	resizeCanvas();

	signClearButton.addEventListener("click", function (event) {
		event.preventDefault();
		signaturePad.clear();
	});

	signAgreeButton.addEventListener("click", function (event) {
		event.preventDefault();
		var error = document.getElementById('signature-pad-error');
		if (signaturePad.isEmpty()) {
			error.innerHTML = signatureError;
		} else {
			error.innerHTML = "";
			$('#signature_src').val(signaturePad.toDataURL());
			$('#application-form').submit();
		}
	});
}

function resizeCanvas() {
    var ratio 			= Math.max(window.devicePixelRatio || 1, 1);
    signCanvas.width 	= signCanvas.offsetWidth * ratio;
    signCanvas.height 	= signCanvas.offsetHeight * ratio;
    signCanvas.getContext("2d").scale(ratio, ratio);
    signaturePad.clear();
}